/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Jade_Crisp_Bear_TurnInputs */

const en_jade_crisp_bear_turn = /** @type {(inputs: Jade_Crisp_Bear_TurnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} answers`)
};

const de_jade_crisp_bear_turn = /** @type {(inputs: Jade_Crisp_Bear_TurnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Antworten`)
};

/**
* | output |
* | --- |
* | "{count} answers" |
*
* @param {Jade_Crisp_Bear_TurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_crisp_bear_turn = /** @type {((inputs: Jade_Crisp_Bear_TurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Crisp_Bear_TurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_crisp_bear_turn(inputs)
	return de_jade_crisp_bear_turn(inputs)
});